import { Link } from 'react-router-dom';
import { CalendarDays, MapPin, ArrowRight } from 'lucide-react';
import { formatDate, formatPrice } from '@/lib/utils';
import EventPoster from './EventPoster';

export default function EventCard({ event }) {
  const hasPoster = (event.title || '').toLowerCase().includes('johannesburg') ||
                    (event.title || '').toLowerCase().includes('south africa') ||
                    (event.title || '').toLowerCase().includes('dallas');

  return (
    <Link
      to={`/events/${event.id}`}
      className="group block"
      data-testid="event-card"
    >
      {/* Image / Poster */}
      <div className="relative overflow-hidden">
        {hasPoster ? (
          <EventPoster eventTitle={event.title} />
        ) : (
          <div className="bg-[#f5f0e8]">
            <img
              src={event.hero_image_url || ''}
              alt={event.title}
              className="w-full object-contain"
            />
          </div>
        )}
        {event.tickets_available === 0 && (
          <div className="absolute inset-0 bg-black/40 flex items-center justify-center">
            <span className="font-heading text-xl text-white tracking-wider uppercase">Sold Out</span>
          </div>
        )}
      </div>

      {/* Content */}
      <div className="pt-5 pb-2">
        <p className="text-[11px] uppercase tracking-[0.15em] text-gray-400 font-body font-medium">
          {event.category}
        </p>
        <h3 className="font-heading text-xl sm:text-2xl font-medium text-gray-900 mt-1 leading-tight">
          {event.title}
        </h3>
        <div className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-1 text-[13px] text-gray-500 font-body">
          <span className="flex items-center gap-1.5">
            <CalendarDays className="h-3.5 w-3.5" />
            {formatDate(event.start_at)}
          </span>
          <span className="flex items-center gap-1.5">
            <MapPin className="h-3.5 w-3.5" />
            {event.location?.split(',')[0]}
          </span>
        </div>
        <div className="mt-4 flex items-center justify-between">
          <span className="font-heading text-lg font-medium text-gray-900">
            {formatPrice(event.price, event.currency)}
          </span>
          <span className="text-[13px] text-gray-500 font-body flex items-center gap-1 group-hover:text-gray-900 transition-colors">
            View Details
            <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-1" />
          </span>
        </div>
      </div>
    </Link>
  );
}
